import {ProfileSeasonModel} from "../../features/profile/profileTypes";
import RankItem from "./RankItem";
import React from "react";
import {Link} from "react-router-dom";

type Props = {
    season: ProfileSeasonModel;
};

const ProfileSeasonItem = ({season}: Props) => {
    return (
        <div className="card mb-1 hover-zoom">
            <div className="position-relative o-hidden">
                <div className="position-absolute w-100 h-100 p-1 z-0">
                    <div>
                        <div className='row'>
                            <div className='col text-right'>
                                <div className='row'>
                                    <div className='col-auto pe-2'>
                                        <div className='rounded-5 overflow-hidden'>
                                            <RankItem results={season.results} trophy={season.trophy}/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <a href={`/event/${season.slug}`}
                   className="position-absolute w-100 h-100 z-1"></a>
                <img className="w-100"
                     src={season.image} alt={season.name}/>
            </div>
        </div>
    )
}

export default ProfileSeasonItem;
